<div class="h-full flex items-center">
    <a
        class="si-header-item btn btn-circle btn-ghost"
        [href]="issuesUrl"
        target="_blank"
        rel="noopener noreferrer"
        [siTooltip]="'header.support.tooltip' | translate"
        [attr.aria-label]="'header.support.aria-label' | translate"
    >
        <si-icon icon="element-support" />
    </a>
</div>
